import { create } from 'zustand';

// Module-scoped: the two entry points are separate trees and Radix unmounts the switcher item on select.
type CreateAgentStore = {
  isCreating: boolean;
  startCreating: () => void;
};

export const useCreateAgentStore = create<CreateAgentStore>((set) => ({
  isCreating: false,
  startCreating: () => set({ isCreating: true }),
}));
